import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { ActionButtonTypesEnum } from 'interface';

import { FULL_COMPONENT_NAME } from '../../constants';

import styles from './ActionButtons.module.scss';

interface ActionButtonsProps {
  isSavingUserLineup: boolean;
  shouldShowCancelButton: boolean;
  shouldShowRevertButton: boolean;
  shouldShowSaveButton: boolean;
  handleClickSaveButton: () => void;
  handleClickRevertButton: () => void;
  handleClickCancelButton: () => void;
}

export const ActionButtons = ({
  isSavingUserLineup,
  shouldShowCancelButton,
  shouldShowRevertButton,
  shouldShowSaveButton,
  handleClickSaveButton,
  handleClickRevertButton,
  handleClickCancelButton,
}: ActionButtonsProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div>
        {shouldShowSaveButton && (
          <ActionButton
            title={intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.buttonSave`, defaultMessage: 'Save' })}
            type={ActionButtonTypesEnum.primary}
            onClick={handleClickSaveButton}
            className={styles.saveButton}
            isPending={isSavingUserLineup}
          />
        )}

        {shouldShowCancelButton && (
          <ActionButton
            title={intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.buttonCancel`, defaultMessage: 'Cancel' })}
            className={cn(styles.transparentButtons, styles.cancelButton)}
            onClick={handleClickCancelButton}
          />
        )}
      </div>

      {shouldShowRevertButton && (
        <ActionButton
          title={intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.buttonReset`, defaultMessage: 'Revert to original' })}
          className={cn(styles.transparentButtons)}
          onClick={handleClickRevertButton}
        />
      )}
    </div>
  );
}
